//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO:BRO-1276: import { DButton, DDropdownItem } from '@appsumo/dorado-nuxt';
import LegacyButton from '../../ui/LegacyButton.vue';
import LegacyDropdown from '../../ui/LegacyDropdown.vue';

export default {
  name: 'PDPFilter',
  components: {
    LegacyButton,
    LegacyDropdown,
  },
  props: {
    showAll: {
      type: Boolean,
    },
    commentTypeTitleLc: {
      type: String,
      required: true,
    },
    showFilter: {
      type: Boolean,
    },
    isUserVerified: {
      type: Boolean,
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    hasPurchased: {
      type: Boolean,
    },
    unapproved: {
      type: Number,
      default: 0,
    },
    unresolved: {
      type: Number,
      default: 0,
    },
    hasItems: {
      type: Boolean,
      required: true,
    },
    commentCount: {
      type: Number,
      required: true,
    },
    allowCreateItem: {
      type: Boolean,
      required: true,
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
    numVisibleComments: {
      type: Number,
      required: true,
    },
    isModeratorView: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    let sortOptions;

    if (this.forReviews) {
      sortOptions = [
        { display: 'Newest', value: 'newest' },
        { display: 'Oldest', value: 'oldest' },
        { display: 'Rating (ascending)', value: 'rating-asc' },
        { display: 'Rating (descending)', value: 'rating-desc' },
        { display: 'Helpful', value: 'helpful' },
      ];
    } else {
      sortOptions = [
        { display: 'Latest reply', value: 'latest' },
        { display: 'Helpful', value: 'helpful' },
        { display: 'Newest', value: 'newest' },
        { display: 'Oldest', value: 'oldest' },
      ];
    }

    const filterBy = [
      { display: 'All', value: 'all' },
      { display: 'Unresolved', value: 'unresolved' },
      { display: 'Pending moderation', value: 'unapproved' },
    ];

    return {
      filterBy,
      sortOptions,
      selectedFilter: filterBy[0],
      selectedSort: sortOptions[0],
    };
  },
  computed: {
    totalCommentsForMod() {
      // because 'commentCount' only counts approved comments, let's include unapproved comments in
      // the total count so that mod's can see an accurate number
      return this.unapproved + this.commentCount;
    },
    hasFilterApplied() {
      return this.selectedFilter.value !== 'all';
    },
    includeFilterTools() {
      if (!this.showFilter) {
        return false;
      }

      return this.hasItems || this.hasFilterApplied;
    },
    verifyEmailTooltipName() {
      return `filterSubmitButtonTooltip-${this.forReviews ? 'r' : 'q'}`;
    },
  },
  methods: {
    onClickFilter(valObj) {
      this.selectedFilter = valObj;
      this.$emit('on-change-filter', { type: 'filter', value: valObj.value });
    },
    onClickSort(valObj) {
      this.selectedSort = valObj;
      this.$emit('on-change-filter', { type: 'sort', value: valObj.value });
    },
    toggleShowAll() {
      this.$emit('toggle-show-all');
    },
    toggleComment() {
      if (this.isUserVerified) {
        this.$emit('toggle-comment');
      }
    },
    onClickRefresh() {
      this.$emit('on-click-refresh');
    },
  },
};
